import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var T = Object.defineProperty;
var y = (e, o, t) => o in e ? T(e, o, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: t
}) : e[o] = t;
var b = (e, o, t) => (y(e, typeof o != "symbol" ? o + "" : o, t), t);
import { Machine as I, batch as v } from '../../machine.js';
import { ActionTypes as R, stackMachines as A } from '../../machines/stack-machine.js';
import { Focus as a, calculateActiveIndex as x } from '../../utils/calculate-active-index.js';
import { ElementPositionState as S, computeVisualPosition as E, detectMovement as L } from '../../utils/element-movement.js';
import { sortByDomNode as M } from '../../utils/focus-management.js';
import { match as m } from '../../utils/match.js';
var F = (t => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(F || {}),
  P = (t => (t[t.Single = 0] = "Single", t[t.Multi = 1] = "Multi", t))(P || {}),
  C = (t => (t[t.Pointer = 0] = "Pointer", t[t.Other = 1] = "Other", t))(C || {}),
  k = (r => (r[r.OpenListbox = 0] = "OpenListbox", r[r.CloseListbox = 1] = "CloseListbox", r[r.GoToOption = 2] = "GoToOption", r[r.Search = 3] = "Search", r[r.ClearSearch = 4] = "ClearSearch", r[r.SelectOption = 5] = "SelectOption", r[r.RegisterOptions = 6] = "RegisterOptions", r[r.UnregisterOptions = 7] = "UnregisterOptions", r[r.SetButtonElement = 8] = "SetButtonElement", r[r.SetOptionsElement = 9] = "SetOptionsElement", r[r.SortOptions = 10] = "SortOptions", r[r.MarkButtonAsMoved = 11] = "MarkButtonAsMoved", r))(k || {});
function g(e) {
  let o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t => t;
  let t = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null,
    n = M(o(e.options.slice()), s => s.dataRef.current.domRef.current),
    i = t ? n.indexOf(t) : null;
  return i === -1 && (i = null), {
    options: n,
    activeOptionIndex: i
  };
}
let D = {
  [1](e) {
    if (e.dataRef.current.disabled || e.listboxState === 1) return e;
    let o = e.buttonElement ? S.Tracked(E(e.buttonElement)) : e.buttonPositionState;
    return _objectSpread(_objectSpread({}, e), {}, {
      activeOptionIndex: null,
      pendingFocus: {
        focus: a.Nothing
      },
      listboxState: 1,
      __demoMode: !1,
      buttonPositionState: o
    });
  },
  [0](e, o) {
    if (e.dataRef.current.disabled || e.listboxState === 0) return e;
    let t = e.activeOptionIndex,
      {
        isSelected: n
      } = e.dataRef.current,
      i = e.options.findIndex(s => n(s.dataRef.current.value));
    return i !== -1 && (t = i), _objectSpread(_objectSpread({}, e), {}, {
      frozenValue: !1,
      pendingFocus: o.focus,
      listboxState: 0,
      activeOptionIndex: t,
      __demoMode: !1,
      buttonPositionState: S.Idle
    });
  },
  [2](e, o) {
    var s, l, c, p, f;
    if (e.dataRef.current.disabled || e.listboxState === 1) return e;
    let t = _objectSpread(_objectSpread({}, e), {}, {
      searchQuery: "",
      activationTrigger: (s = o.trigger) != null ? s : 1,
      __demoMode: !1
    });
    if (o.focus === a.Nothing) return _objectSpread(_objectSpread({}, t), {}, {
      activeOptionIndex: null
    });
    if (o.focus === a.Specific) return _objectSpread(_objectSpread({}, t), {}, {
      activeOptionIndex: e.options.findIndex(d => d.id === o.id)
    });
    if (o.focus === a.Previous) {
      let d = e.activeOptionIndex;
      if (d !== null) {
        let O = e.options[d].dataRef.current.domRef,
          r = x(o, {
            resolveItems: () => e.options,
            resolveActiveIndex: () => e.activeOptionIndex,
            resolveId: u => u.id,
            resolveDisabled: u => u.dataRef.current.disabled
          });
        if (r !== null) {
          let u = e.options[r].dataRef.current.domRef;
          if (((l = O.current) == null ? void 0 : l.previousElementSibling) === u.current || ((c = u.current) == null ? void 0 : c.previousElementSibling) === null) return _objectSpread(_objectSpread({}, t), {}, {
            activeOptionIndex: r
          });
        }
      }
    } else if (o.focus === a.Next) {
      let d = e.activeOptionIndex;
      if (d !== null) {
        let O = e.options[d].dataRef.current.domRef,
          r = x(o, {
            resolveItems: () => e.options,
            resolveActiveIndex: () => e.activeOptionIndex,
            resolveId: u => u.id,
            resolveDisabled: u => u.dataRef.current.disabled
          });
        if (r !== null) {
          let u = e.options[r].dataRef.current.domRef;
          if (((p = O.current) == null ? void 0 : p.nextElementSibling) === u.current || ((f = u.current) == null ? void 0 : f.nextElementSibling) === null) return _objectSpread(_objectSpread({}, t), {}, {
            activeOptionIndex: r
          });
        }
      }
    }
    let n = g(e),
      i = x(o, {
        resolveItems: () => n.options,
        resolveActiveIndex: () => n.activeOptionIndex,
        resolveId: d => d.id,
        resolveDisabled: d => d.dataRef.current.disabled
      });
    return _objectSpread(_objectSpread(_objectSpread({}, t), n), {}, {
      activeOptionIndex: i
    });
  },
  [3]: (e, o) => {
    if (e.dataRef.current.disabled || e.listboxState === 1) return e;
    let n = e.searchQuery !== "" ? 0 : 1,
      i = e.searchQuery + o.value.toLowerCase(),
      l = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + n).concat(e.options.slice(0, e.activeOptionIndex + n)) : e.options).find(p => {
        var f;
        return !p.dataRef.current.disabled && ((f = p.dataRef.current.textValue) == null ? void 0 : f.startsWith(i));
      }),
      c = l ? e.options.indexOf(l) : -1;
    return c === -1 || c === e.activeOptionIndex ? _objectSpread(_objectSpread({}, e), {}, {
      searchQuery: i
    }) : _objectSpread(_objectSpread({}, e), {}, {
      searchQuery: i,
      activeOptionIndex: c,
      activationTrigger: 1
    });
  },
  [4](e) {
    return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : _objectSpread(_objectSpread({}, e), {}, {
      searchQuery: ""
    });
  },
  [5](e) {
    return e.dataRef.current.mode === 0 ? _objectSpread(_objectSpread({}, e), {}, {
      frozenValue: !0
    }) : _objectSpread({}, e);
  },
  [6]: (e, o) => {
    let t = e.options.concat(o.options),
      n = e.activeOptionIndex;
    if (e.pendingFocus.focus !== a.Nothing && (n = x(e.pendingFocus, {
      resolveItems: () => t,
      resolveActiveIndex: () => e.activeOptionIndex,
      resolveId: i => i.id,
      resolveDisabled: i => i.dataRef.current.disabled
    })), e.activeOptionIndex === null) {
      let {
        isSelected: i
      } = e.dataRef.current;
      if (i) {
        let s = t.findIndex(l => i == null ? void 0 : i(l.dataRef.current.value));
        s !== -1 && (n = s);
      }
    }
    return _objectSpread(_objectSpread({}, e), {}, {
      options: t,
      activeOptionIndex: n,
      pendingFocus: {
        focus: a.Nothing
      },
      pendingShouldSort: !0
    });
  },
  [7]: (e, o) => {
    let t = e.options,
      n = [],
      i = new Set(o.options);
    for (let [s, l] of t.entries()) if (i.has(l.id) && (n.push(s), i.delete(l.id), i.size === 0)) break;
    if (n.length > 0) {
      t = t.slice();
      for (let s of n.reverse()) t.splice(s, 1);
    }
    return _objectSpread(_objectSpread({}, e), {}, {
      options: t,
      activationTrigger: 1
    });
  },
  [8]: (e, o) => e.buttonElement === o.element ? e : _objectSpread(_objectSpread({}, e), {}, {
    buttonElement: o.element
  }),
  [9]: (e, o) => e.optionsElement === o.element ? e : _objectSpread(_objectSpread({}, e), {}, {
    optionsElement: o.element
  }),
  [10]: e => e.pendingShouldSort ? _objectSpread(_objectSpread(_objectSpread({}, e), g(e)), {}, {
    pendingShouldSort: !1
  }) : e,
  [11](e) {
    return e.buttonPositionState.kind !== "Tracked" ? e : _objectSpread(_objectSpread({}, e), {}, {
      buttonPositionState: S.Moved
    });
  }
};
class h extends I {
  constructor(t) {
    super(t);
    b(this, "actions", {
      onChange: t => {
        let {
          onChange: n,
          compare: i,
          mode: s,
          value: l
        } = this.state.dataRef.current;
        return m(s, {
          [0]: () => n == null ? void 0 : n(t),
          [1]: () => {
            let c = l.slice(),
              p = c.findIndex(f => i(f, t));
            return p === -1 ? c.push(t) : c.splice(p, 1), n == null ? void 0 : n(c);
          }
        });
      },
      registerOption: v(() => {
        let t = [],
          n = new Set();
        return [(i, s) => {
          n.has(s) || (n.add(s), t.push({
            id: i,
            dataRef: s
          }));
        }, () => (n.clear(), this.send({
          type: 6,
          options: t.splice(0)
        }))];
      }),
      unregisterOption: v(() => {
        let t = [];
        return [n => t.push(n), () => {
          this.send({
            type: 7,
            options: t.splice(0)
          });
        }];
      }),
      goToOption: v(() => {
        let t = null;
        return [(n, i) => {
          t = _objectSpread(_objectSpread({
            type: 2
          }, n), {}, {
            trigger: i
          });
        }, () => t && this.send(t)];
      }),
      closeListbox: () => {
        this.send({
          type: 1
        });
      },
      openListbox: t => {
        this.send({
          type: 0,
          focus: t
        });
      },
      selectActiveOption: () => {
        var t;
        if (this.state.activeOptionIndex !== null) {
          let {
            dataRef: n
          } = this.state.options[this.state.activeOptionIndex];
          this.actions.selectOption(n.current.value);
        } else this.state.dataRef.current.mode === 0 && (this.actions.closeListbox(), (t = this.state.buttonElement) == null || t.focus({
          preventScroll: !0
        }));
      },
      selectOption: t => {
        this.send({
          type: 5,
          value: t
        });
      },
      search: t => {
        this.send({
          type: 3,
          value: t
        });
      },
      clearSearch: () => {
        this.send({
          type: 4
        });
      },
      setButtonElement: t => {
        this.send({
          type: 8,
          element: t
        });
      },
      setOptionsElement: t => {
        this.send({
          type: 9,
          element: t
        });
      }
    });
    b(this, "selectors", {
      activeDescendantId(t) {
        var s;
        let n = t.activeOptionIndex,
          i = t.options;
        return n === null || (s = i[n]) == null ? void 0 : s.id;
      },
      isActive(t, n) {
        var l;
        let i = t.activeOptionIndex,
          s = t.options;
        return i !== null ? ((l = s[i]) == null ? void 0 : l.id) === n : !1;
      },
      hasFrozenValue(t) {
        return t.frozenValue;
      },
      shouldScrollIntoView(t, n) {
        return t.__demoMode || t.listboxState !== 0 || t.activationTrigger === 0 ? !1 : this.isActive(t, n);
      },
      didButtonMove(t) {
        return t.buttonPositionState.kind === "Moved";
      }
    });
    this.on(6, () => {
      requestAnimationFrame(() => {
        this.send({
          type: 10
        });
      });
    });
    {
      let n = this.state.id,
        i = A.get(null);
      this.disposables.add(i.on(R.Push, s => {
        !i.selectors.isTop(s, n) && this.state.listboxState === 0 && this.actions.closeListbox();
      })), this.on(0, () => i.actions.push(n)), this.on(1, () => i.actions.pop(n));
    }
    this.disposables.group(n => {
      this.on(1, i => {
        i.buttonElement && (n.dispose(), n.add(L(i.buttonElement, i.buttonPositionState, () => {
          this.send({
            type: 11
          });
        })));
      });
    }), this.on(5, (n, i) => {
      var s;
      this.actions.onChange(i.value), this.state.dataRef.current.mode === 0 && (this.actions.closeListbox(), (s = this.state.buttonElement) == null || s.focus({
        preventScroll: !0
      }));
    });
  }
  static new(_ref) {
    let {
      id: t,
      __demoMode: n = !1
    } = _ref;
    return new h({
      id: t,
      dataRef: {
        current: {}
      },
      listboxState: n ? 0 : 1,
      options: [],
      searchQuery: "",
      activeOptionIndex: null,
      activationTrigger: 1,
      buttonElement: null,
      optionsElement: null,
      pendingShouldSort: !1,
      pendingFocus: {
        focus: a.Nothing
      },
      frozenValue: !1,
      __demoMode: n,
      buttonPositionState: S.Idle
    });
  }
  reduce(t, n) {
    return m(n.type, D, t, n);
  }
}
export { k as ActionTypes, C as ActivationTrigger, h as ListboxMachine, F as ListboxStates, P as ValueMode };